import { render, staticRenderFns } from "./VContentBox.vue?vue&type=template&id=8a755bf0&"
import script from "./VContentBox.vue?vue&type=script&lang=ts&"
export * from "./VContentBox.vue?vue&type=script&lang=ts&"
import style0 from "./VContentBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports